import { Box, Fab, Grid, TextField, Tooltip, Typography } from '@mui/material'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import SaveIcon from '@mui/icons-material/Save'
import React, { FC } from 'react'

type TextfieldProps = {
    value: string,
    onChange(event: React.ChangeEvent<{ value: unknown }>): void
}

interface IProps {
    title: string

    name: TextfieldProps
    value: TextfieldProps

    button: {
        text: string,
        onClick(): void
    }

    needSave?: boolean
    // editable: boolean
}

const MarkupUIBox: FC<IProps> = props => {

    return (
        <Box
            display='flex'
            flexDirection='column'
            alignItems='center'
            pb={2}
            style={{
                width: 400,
                height: 'fit-content',
                margin: 15,
                border: '1px solid black',
                maxHeight: '90%',
                overflowY: 'auto',
                overflowX: 'hidden',
                position: 'relative'
            }}
        >

            <Box
                py={1}
                style={{
                    position: 'sticky',
                    top: 0,
                    width: '100%',
                    backgroundColor: 'white',
                    zIndex: 10
                }}>
                <Grid container spacing={2}>
                    <Grid item xs={3}> </Grid>
                    <Grid item xs={6} container justifyContent='center' alignItems='center'>
                        <Typography variant='h6'>{props.title}</Typography>
                    </Grid>
                    <Grid item xs={3} container justifyContent='flex-end' alignItems='center'>
                        <Tooltip title={props.title === 'New Markup' ? 'Create' : 'Save'}>
                            <Fab
                                color={props.needSave ? 'secondary' : "primary"}
                                size='small'
                                onClick={props.button.onClick}
                                style={{ marginRight: 10 }}
                            >
                                {props.title === 'New Markup' ? <NoteAddIcon /> : <SaveIcon />}
                            </Fab>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Box>


            <TextField
                label="Markup Name"
                variant="outlined"
                value={props.name.value}
                onChange={props.name.onChange}
                style={{ width: '60%', marginTop: 15 }}
            // disabled={!props.editable}
            />

            <TextField
                label="Markup Value"
                variant="outlined"
                type='number'
                value={props.value.value}
                onChange={props.value.onChange}
                style={{ width: '60%', marginTop: 15 }}
            // disabled={!props.editable}
            />

        </Box >
    )
}

export default MarkupUIBox